import React, { useState, useEffect } from 'react';
import axios from 'axios';

const monedas = ['USD', 'EUR', 'GBP', 'BRL', 'ARS'];

export default function CotizacionAdmin() {
  const [valores, setValores] = useState({});
  const [cotizaciones, setCotizaciones] = useState([]);

  const cargarCotizaciones = async () => {
    // const res = await axios.get('http://localhost:8080/api/cotizaciones');
    // setCotizaciones(res.data);

    // 🔧 Simulación local
    setCotizaciones([
      { fecha: '2025-07-15', moneda: 'USD', valor: 7300 },
      { fecha: '2025-07-15', moneda: 'EUR', valor: 8000 },
      { fecha: '2025-07-14', moneda: 'USD', valor: 7200 },
      { fecha: '2025-07-14', moneda: 'EUR', valor: 7900 }
    ]);
  };

  useEffect(() => {
    cargarCotizaciones();
  }, []);

  const handleChange = (moneda, valor) => {
    setValores(prev => ({ ...prev, [moneda]: valor }));
  };

  const handleSubmit = async () => {
    const fechaHoy = new Date().toISOString().split('T')[0];
    const nuevas = monedas
      .filter((moneda) => valores[moneda])
      .map((moneda) => ({
        fecha: fechaHoy,
        moneda,
        valor: parseFloat(valores[moneda])
      }));

    // 🔧 Simulación local: actualizamos localmente
    setCotizaciones((prev) => [...prev, ...nuevas]);
    alert('Cotizaciones guardadas');
    setValores({});
    // cargarCotizaciones(); // ya no es necesario, porque actualizamos localmente
  };


  return (
    <div className="p-6 max-w-3xl mx-auto space-y-8 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold text-center">💱 Cotizaciones</h2>

      <div className="grid grid-cols-2 gap-4">
        {monedas.map(moneda => (
          <div key={moneda} className="flex justify-between items-center">
            <label>{moneda}</label>
            <input
              type="number"
              step="0.01"
              value={valores[moneda] || ''}
              onChange={e => handleChange(moneda, e.target.value)}
              placeholder={`Ej: 7300`}
              className="border rounded px-2 py-1 w-32 text-right"
            />
          </div>
        ))}
      </div>

      <button onClick={handleSubmit} className="w-full bg-blue-600 text-white py-2 rounded">
        Guardar/Actualizar Cotizaciones de Hoy
      </button>

      <hr className="my-4" />

      <h3 className="text-xl font-semibold">Historial de Cotizaciones</h3>
      <table className="w-full table-auto border text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-2 py-1">Fecha</th>
            <th className="border px-2 py-1">Moneda</th>
            <th className="border px-2 py-1">Valor</th>
          </tr>
        </thead>
        <tbody>
          {cotizaciones.map((c) => (
            <tr key={`${c.moneda}-${c.fecha}`}>
              <td className="border px-2 py-1">{c.fecha}</td>
              <td className="border px-2 py-1">{c.moneda}</td>
              <td className="border px-2 py-1">{c.valor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
